<div class="company-main-banner">
  <div class="message">
    <p>Small but sound and smart</p>
    <p>Hyundai Green Tech</p>
  </div>
</div>
<div class="company-message">
  <div class="content">
    믿음, 내실을 추구하는 미래지향적 기업<br />
    이것이 현대그린테크 주식회사가 지향하는 목표입니다.<br />
    회사규모는 작지만 건전하고 기본원칙에 충실 하는 기업을 모토로 합니다.<br />
    최고의 제품과 서비스를 제공합니다.
  </div>
</div>
<div class="department-container">
  <div class="departments">
    <div class="dept-image-semi"></div>
    <div class="dept-content">
      <p>반도체 사업부</p>
      <p>당 사업부는 SK HYNIX 공식대리점으로서 DRAM, Mobile DRAM,<br />
        Flash Memory ,MCP 등 SK HYNIX 에서 생산되는 전 제품군을 취급하고<br />
        있으며, 다양한 산업분야에 최적화된 솔루션을 제공하고 전문인력 기반의<br />
        기술지원 및 영업 능력을 활용 반도체 시장 개척을 위하여 부단히<br />
        노력하고 있습니다.</p>
      <p style="cursor: pointer;" (click)="viewPage('semi_intro')">VIEW MORE ></p>
    </div>
  </div>
  <div class="departments">
    <div class="dept-content" style="margin-left: 0px; margin-right: 75px;">
      <p>판금 사업부</p>
      <p>정밀판금 사업부는 Laser, NCT, Bending M/C등 다량의 판금 장비를 보유하고<br />
        있습니다. 특히 기구 설계에서부터 생산, 도장, 조립에 이르기까지 완벽한 일괄<br />
        생산 라인은 고객의 경쟁력 제고강화를 목표로 한 최적의 시스템을 구축하게<br />
        되었습니다. 국내 판금업계에서 십 수년 이상 근무 경험을 가지고 있는 많은<br />
        전문 기술인력으로 구성되어 있습니다.</p>
      <p style="cursor: pointer;" (click)="viewPage('metal_intro')">VIEW MORE ></p>
    </div>
    <div class="dept-image-metal"></div>
  </div>
  <div class="departments">
    <div class="dept-image-rnd"></div>
    <div class="dept-content">
      <p>연구전담 부서</p>
      <p>당 연구전담부서는 엘리베이터에 전자기술을 접합한 Mobile Call, Elevator<br />
        환경실험 관련 Inhalation Chamber 등을 개발 완료하여 국내 시장에<br />
        판매 중입니다. 또한, 최근 정보 인식 기술의 핵심으로 자리 잡은 RFID TAG 개발 및<br />
        양산 중에 있습니다.</p>
      <p style="cursor: pointer;" (click)="viewPage('rnd_intro')">VIEW MORE ></p>
    </div>
  </div>
</div>
<div nz-row class="company-main-bottom">
  <div nz-col class="left">
    <div class="center-parent" style="text-align: left; height: 100%;">
      <div class="center-child" style="transform: translate(-25%, -50%);">
        <h6>Customer center</h6>
        <p>
          반도체 사업부<br />
          [영업1팀] : T. 02-2115-8804 E. kisangpark@hyundaigreen.com<br />
          [영업2팀] : T. 02-2115-8805 E. austin@hyundaigreen.com<br />
          <br />
          판금 사업부<br />
          [영업팀] : T.041-582-2214 E. jhs6208kr@hyundaigreen.com<br />
        </p>
      </div>
    </div>
  </div>
  <div nz-col class="right">
    <div nz-row class="right-top">
      <div nz-col class="center-parent">
        <h6 class="center-child">Our vision</h6>
      </div>
    </div>
    <div nz-row class="right-bottom">
      <div nz-col class="center-parent">
        <h6 class="center-child">사업장 소개</h6>
      </div>
      <div nz-col></div>
    </div>
  </div>
</div>
<div nz-row class="company-main-partners">
  <p nz-row style="margin-bottom: 0px;">Our partners</p>
  <div nz-row class="partner-logos"></div>
</div>
<div class="main-footer" nz-row>
  <p>COPYRIGHT BY (C) 2009 HYUNDAI GREEN TECH ALL RIGHTS RESERVED.<br/>
    [SEOUL]  T 02-2115-8815  F 02-2115-8818  [CHEON-AN] T 041-582-2214, 2215  F 041-588-2215</p>
</div>
